import * as React from "react";
import { styled } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputBase from "@mui/material/InputBase";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(1.5),
  },
  "& .MuiInputBase-input": {
    display: "flex",
    alignItems: "center",
    borderRadius: 10,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "5px 8px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}));

export default function QuickSelector({
  value,
  title = "Quick filter",
  setValue,
  options = [],
}) {
  const handleChange = (event) => {
    setValue(event.target.value);
  };
  return (
    <FormControl sx={{ minWidth: 120 }}>
      <Select
        displayEmpty
        value={value}
        size="small"
        onChange={handleChange}
        input={<BootstrapInput />}
      >
        <MenuItem value="">
          <em>{title}</em>
        </MenuItem>
        {options.map((op) => (
          <MenuItem value={op.value}>
            {op.Icon}
            {op.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
